import {TStore} from 'models';

export const selectAppTimezones = (state: TStore) =>
    state?.app?.data?.timezones;

export const selectAppLoading = (state: TStore) => state?.app?.loading;
export const selectIsWelcomeVideoOpen = (state: TStore) =>
    state?.auth?.isWelcomeVideoOpen;

export const selectAppConnectionIssue = (state: TStore) =>
    state?.app?.connectionIssue;
